import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Nav from "./components/Nav.jsx";
import Events from "./pages/Events.jsx";
import TermsAndConditions from "./components/TermsAndConditions.jsx";
import Connect from "./components/Connect.jsx";
import Footer from "./components/Footer.jsx";
import "./App.css";

function App() {
  return (
    <>
      <div className="main">
        <div className="main-nav">
          <Nav />
        </div>
        <div className="main-content">
          <Router>
            <Routes>
              <Route path="/" element={<Events />} />
              <Route
                path="/terms-and-conditions"
                element={<TermsAndConditions />}
              />
            </Routes>
          </Router>
          <Connect />
          <Footer />
        </div>
      </div>
    </>
  );
}

export default App;
